import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

import "./css/pages/HomePage.css";
import "./css/dashboard/dashboard.css";
import "./css/dashboard/GlazmaReviewsPage.css";
import "./css/others/LoadingPage.css";
import "./css/dashboard/DashboardHomePage.css";
import "./css/pages/forgotpassword.css";
import "./css/pages/ViewReviewDetails.css";
import "./css/pages/Settings.css";
import "./css/customerePage/Glazmacspage.css";

import HomePage from "./pages/HomePage";
import AdminDashBoard from "./pages/AdminDashBoard";
import GlazmaReviewsPage from "./component/dashboard/GlazmaReviewsPage";
import DashboardHomePage from "./component/dashboard/DashboardHomePage";
import Settings from "./component/dashboard/Settings";
import LoadingPage from "./others/LoadingPage";
import ProtectedRoute from "./component/dashboard/ProtectedRoute";
import PublicRoute from "./component/dashboard/PublicRoute";
import ForgotPasswordFlow from "./component/forgotPassword/ForgotPasswordFlow";
import ViewReviewDetails from "./component/dashboard/ViewReviewDetails";
import Unauthorized from "./others/Unauthorized";
import FTreviewPage from "./component/dashboard/FTreviewPage";
import GocReviewPage from "./component/dashboard/GocReviewPage";
import Glazmacspage from "./component/customerevPage/Glazmacspage";

import { useAuth } from "./auth/AuthContext";
import { use } from "react";
import BHUMUreviewPage from "./component/dashboard/BHUMUreviewPage";
import ThanksFeedback from "./component/customerevPage/ThanksFeedback";
import GOCcspage from "./component/customerevPage/GOCcspage";
import FTcsPage from "./component/customerevPage/FTcsPage";
import Bhumucspage from "./component/customerevPage/Bhumucspage";

function App() {
  const { user, loading } = useAuth();

  return (
    <BrowserRouter>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        {/* <Route path="/" element={<HomePage/>}></Route> */}

        <Route element={<PublicRoute />}>
          <Route path="/" element={<HomePage />} />
        </Route>

        <Route path="/loading" element={<LoadingPage />}></Route>
        <Route path="/forgot-password" element={<ForgotPasswordFlow />} />

        <Route path="/glazma-your-feedback" element={<Glazmacspage />}></Route>
        <Route path="/goc-your-feedback" element={<GOCcspage />}>
          {" "}
        </Route>
        <Route path="/fluffytouch-feedback" element={<FTcsPage />}></Route>

        <Route path="/bhumu-feedback" element={<Bhumucspage />}>
          {" "}
        </Route>

        <Route path="/thanks-feedback" element={<ThanksFeedback />}></Route>

        <Route element={<ProtectedRoute />}>
          <Route path="/auth/v6/dash-board" element={<AdminDashBoard />}>
            <Route index element={<DashboardHomePage />} />

            <Route
              path="glazma-reviews-manage"
              element={
                <ProtectedRoute allowedPage="Glazma">
                  <GlazmaReviewsPage User={user} />
                </ProtectedRoute>
              }
            />

            <Route
              path="fluffytouch-reviews-manage"
              element={
                <ProtectedRoute allowedPage="FluffyTouch">
                  <FTreviewPage User={user} />
                </ProtectedRoute>
              }
            />

            <Route
              path="goc-reviews-manage"
              element={
                <ProtectedRoute allowedPage="GOC">
                  <GocReviewPage User={user} />
                </ProtectedRoute>
              }
            />

            <Route
              path="bhumu-reviews-manage"
              element={
                <ProtectedRoute allowedPage="BHUMU">
                  <BHUMUreviewPage User={user} />
                </ProtectedRoute>
              }
            />

            <Route path="unauthorized" element={<Unauthorized />} />
            <Route
              path="settings"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <Settings />
                </ProtectedRoute>
              }
            />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
